import DynamicForm from "components/DynamicForm";
import { ButtonV1 } from "lib";
import React, { Fragment, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedData } from "redux/formDisplay";
import { uniqueWorkFlowId } from "helper/uniqueWorkFlowId";
import { createMasterDataPayload } from "helper/createPayload";

import {
  createBulkPrimaryWorkFlows,
} from "api/formDisplay";

function BulkInviteCustomer(props) {

  const { showModal, closeModal, model_name } = props;
  const [formErr, setFormErr] = useState({});
  const [successModal, setsuccessModal] = useState(false)
  const dispatch = useDispatch();
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const { dashboardConfig } = useSelector((state) => state.dashboardReducer);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const bulk = useSelector((state) => state.formData?.bulkaddCustomer);
  const isEmailVerified = useSelector(
    (state) => state.otpReducer?.isEmailVerified
  );
  const isMobileVerified = useSelector(
    (state) => state.otpReducer?.isMobileVerified
  );
  const organisation_id = dashboardConfig?.organisation_id;
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo)
  
  const handleclose = () => {
    closeModal()
    setsuccessModal(false)
  };
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  let loggedInUserName = loggedUserId ? (`${(loggedInUserInfo?.profileInfo?.first_name || "") + " " + (loggedInUserInfo?.profileInfo?.last_name || "")}`) : "";
  let loggedInUserEmail = loggedUserId && loggedInUserInfo?.profileInfo?.emailId
  let loggedInUserMobileNumber = loggedUserId && loggedInUserInfo?.profileInfo?.mobileNumber

  const activeStepOrder = useSelector(
    (state) => state.conditionalRendering?.activeStepOrder
  );
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const queryPath = query.get("physical_form");

  const handleNext = async () => {
    try {
      const payloadArray = bulk.validUserData;
      const finalPayloadArray = [];
      for (let record of payloadArray) {
        let order = activeStepOrder;
        let sourceDataFields = bulk.sourceData_fields
        const deletedFields = {};
        for (const fieldObj of sourceDataFields) {
          const fieldName = fieldObj.id;
          if (record && typeof record === 'object' && record.hasOwnProperty(fieldName)) {
            deletedFields[fieldName] = record[fieldName];
            record = Object.fromEntries(
              Object.entries(record).filter(([key]) => key !== fieldName)
            );
          }
        }
        let saveData = [];
        saveData.push(record)
        let applicant_sequence = bulk?.application_sequence
        let finalPayload
        const dynamicConfigId = dashboardConfig.wf_configuration_id
        const configurationId = dashboardConfig.wf_configuration_id
        let uniqueName = bulk?.application_sequence ? bulk?.application_sequence : bulk?.wf_name
        let application_ref_id = uniqueWorkFlowId(uniqueName)
        finalPayload = await createMasterDataPayload(
          null,
          deletedFields,
          organisation_id,
          configurationId,
          saveData,
          isEmailVerified,
          isMobileVerified,
          null,
          null,
          null,
          order,
          dynamicConfigId,
          application_ref_id,
          loggedUserId,
          applicant_sequence,
          loggedInUserName,
          loggedInUserEmail,
          loggedInUserMobileNumber,
          null,
          null,
          null,
          null,
          null
        );
        if (queryPath) {
          //Changed Key physical_form to verification
          finalPayload.verification = true; 
        } else {
          finalPayload.verification = false;
        }
        finalPayloadArray.push(finalPayload);
      }
      dispatch(createBulkPrimaryWorkFlows(finalPayloadArray));
      closeModal()
      setsuccessModal(true)
    } catch (error) {
      console.error("Error in handleNext:", error);
    }
  };

  return (
    <>
      {!successModal ? (
        <>
          <Modal
            show={showModal}
            onHide={closeModal}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            size="md"
          >
            {
              <>
                <Modal.Header className="pb-0">
                  <button className="btn btn-close top-0 end-0 mt-3 me-3 position-absolute " onClick={handleclose}>
                  </button>

                  <Modal.Title className="text-theme-primary fw-bold">{model_name ? `${model_name}` : "Add Bulk Customer"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-0">
                  <div className=".d-flex align-items-center">
                  {dashboardConfig?.add_bulk_customer_form?.form_elements?.map(
                        (item, index) => {
                          if (IndirectEval(item?.show)) {
                            return (
                              <Fragment key={index}>
                                <Row>
                                  <DynamicForm
                                    formFields={item}
                                    formErr={formErr}
                                    setFormErr={setFormErr}
                                    selectedData={selectedData}
                                    setSelectedData={setSelectedData}
                                  />
                                </Row>
                              </Fragment>
                            );
                          }
                        }
                      )
                      }
                  </div>
                </Modal.Body>
              </>
            }
            {!model_name &&
              <Modal.Footer>
                <div>
                  {
                    <>
                      <ButtonV1
                        label="Add Bulk Customer"
                        className="primary_button"
                        variant="primary"
                        onClick={handleNext}
                        disabled={(selectedData.upload_csv_file && bulk?.validUserData) ? false : true}
                      />
                    </>
                  }
                </div>
              </Modal.Footer>
            }
          </Modal>

        </>
      ) :
        (
          <Modal
              onHide={handleclose}
              centered
              show={successModal}>
              <Modal.Body className="p-5">
                <div className="align-items-center d-flex flex-column justify-content-center">
                  <span className="mb-4">
                  
                  <svg xmlns="http://www.w3.org/2000/svg" width="90.818" height="90.818" viewBox="0 0 90.818 90.818">
                    <g id="Group_2010" data-name="Group 2010" transform="translate(0 0)">
                      <path id="Path_947" data-name="Path 947" d="M173.079,304.959A45.409,45.409,0,1,1,127.67,259.55a45.409,45.409,0,0,1,45.409,45.409Z" transform="translate(-82.261 -259.55)" fill="#003975" opacity="0.1" />
                      <path id="Path_948" data-name="Path 948" d="M156.01,301.639a31.658,31.658,0,1,1-31.657-31.657A31.658,31.658,0,0,1,156.01,301.639Z" transform="translate(-78.77 -256.057)" fill="#003975" />
                      <path id="Path_949" data-name="Path 949" d="M105.928,296.713l8.854,8.854,21.9-21.9a1.32,1.32,0,0,1,1.863,0l1.4,1.4a1.316,1.316,0,0,1,0,1.863L117.111,309.76l-1.4,1.4a1.317,1.317,0,0,1-1.425.289h0a1.311,1.311,0,0,1-.437-.287l-1.4-1.4-9.786-9.785a1.319,1.319,0,0,1,0-1.865l1.4-1.4a1.318,1.318,0,0,1,1.862,0Z" transform="translate(-75.825 -251.948)" fill="#fff" />
                    </g>
                  </svg>

                  </span>
                  <p>
                    Customers have been Added Successfully
                  </p>
                </div>
              </Modal.Body>
            </Modal>
        )
      }
    </>
  );
}

export default BulkInviteCustomer;
